import ProsConsList from "./prosConsList";
import VendorOffer from "./vendorOffer";
// import { Buyer } from "@genericTypes/sharedTypes";
import { GQLOffers } from "@gql/types/gql";
export default function BuyerItemSecondary({
    buyer,
    categoryId,
}: {
    buyer: GQLOffers;
    categoryId: number;
}) {
    const cons = buyer.cons?.map((el) => el?.description) as string[];
    const pros = buyer.pros?.map((el) => el?.description) as string[];
    return (
        <>
            <div
                className="lg:text-lg lg:leading-8 lg:mt-5  text-sm leading-6 mt-12 summary"
                itemProp="description"
                dangerouslySetInnerHTML={{
                    __html: buyer.summaryDescription as string,
                }}
            />

            {pros.length | cons.length ? (
                <div className="mt-12 flex flex-col lg:flex-row   lg:gap-20 gap-7">
                    <div className=" lg:w-1/2 w-full">
                        <ProsConsList list={pros} type="pros" />
                    </div>
                    <div className=" lg:w-1/2 w-full">
                        <ProsConsList list={cons} type="cons" />
                    </div>
                </div>
            ) : (
                <></>
            )}

            <VendorOffer buyer={buyer} categoryId={categoryId} />
        </>
    );
}
